import { CandleTrailLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/CandleTrailLine';
import { CandleTrailTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/CandleTrailTacticPanel';
import { AddCandleTrailTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddCandleTrailTacticPanel';
import { CandleTrailWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/CandleTrailModule/wrapper/CandleTrailWrapper';
import CandleTrailDocs from '../../../../components/forms/tradeplans/documentation/CandleTrailDocumentation';
import CandleTrailModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/CandleTrailModule';
import { CandleTrailData } from './candleTrailData';
import { validateCandleTrail } from './validateCandleTrail';


export const CandleTrail = {
  //data class
  dataStore: CandleTrailData,

  //string constants
  name: 'CANDLE_TRAIL',
  tacticLabel: 'Candle Trail',
  addTacticLabel: 'Add Candle Trail',
  category: 'Exit',

  // components
  tradePlanFormModule: CandleTrailModule,
  tacticPanel: CandleTrailTacticPanel,
  addTacticPanel: AddCandleTrailTacticPanel,
  wrapper: CandleTrailWrapper,
  chartSoftOrderComponent: CandleTrailLine,
  documentation: CandleTrailDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateCandleTrail,
};
